import React, { useState } from "react";
import { ContentContainer } from "../../../components/layout";
import {
  Button,
  LinearProgressBar,
  Modal,
  MultiSelect,
  NoDataFoundTemplate,
  Select,
} from "../../../components/core";
import {
  useApolloClient,
  useLazyQuery,
  useMutation,
  useQuery,
} from "@apollo/client";
import {
  ADD_PARTNER_BRANCH_ASSIGNMENT,
  DELETE_PARTNER_BRANCH_ASSIGNMENT,
  GET_PARTNERS_WITH_OR_WITHOUT_ID,
  LOCKER_TYPES,
  PARTNER_BRANCH_ASSIGNMENT_BY_UNASSIGNED_LOCKERS,
  PARTNER_BRANCH_ASSIGNMENTS_BY_ASSIGNED_BRANCHES,
  PARTNER_BRANCH_ASSIGNMENTS_BY_ASSIGNED_LOCKERS,
} from "../../../constants/graphql/locker-queries";
import { useDispatch, useSelector } from "react-redux";
import {
  clearBrachesLockerAssignmentData,
  clearSearchData,
  getBrachesLockerAssignmentData,
  getLockerTypeList,
  getPartnerList,
  getUnassignedBranchList,
  getUnassignedLockerList,
  handleAssignedBranchLockerData,
  handleOnChanged,
} from "../../../features/assign-to-branch/assign-to-branch-slice";
import { BRANCHES } from "../../../constants/graphql/partner-agent-queries";
import OutputTable from "./components/output-table";
import { setSearchDataReducer } from "../../../features/branches/search-branches-slice";
import { CompareArray } from "../../../algorithms/compare-array";

export default function AssignToBranch() {
  const accessPermission = useSelector(
    (state) => state.accessPermissions.accessPermissions
  );
  const client = useApolloClient();
  const dispatch = useDispatch();
  // Local STates
  const [lastBranchesValue, setLastBranchValue] = React.useState(null);
  const [noBranchesSimilar, setNoBranchesSimilar] = React.useState(false);
  const [modify, setModify] = React.useState(false);
  // Redux States
  const searchData = useSelector((state) => state.assignToBranch.searchData);
  const brachesLockerAssignmentData = useSelector(
    (state) => state.assignToBranch.brachesLockerAssignmentData
  );
  const assignedBranchLockerData = useSelector(
    (state) => state.assignToBranch.assignedBranchLockerData
  );
  const partnerList = useSelector((state) => state.assignToBranch.partnerList);
  const lockerTypeList = useSelector(
    (state) => state.assignToBranch.lockerTypeList
  );
  const unassignedLockerList = useSelector(
    (state) => state.assignToBranch.unassignedLockerList
  );
  const unassignedBranchList = useSelector(
    (state) => state.assignToBranch.unassignedBranchList
  );
  const lockerTypes = useQuery(LOCKER_TYPES);
  const searchPartners = useQuery(GET_PARTNERS_WITH_OR_WITHOUT_ID, {
    variables: {
      operatorId: localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user")).operator_id
        : "",
    },
  });
  const partnerBranchAssignmentsByAssignedBranchesQuery = useQuery(
    PARTNER_BRANCH_ASSIGNMENTS_BY_ASSIGNED_BRANCHES
  );
  const partnerBranchAssignmentsByAssignedLockersQuery = useQuery(
    PARTNER_BRANCH_ASSIGNMENTS_BY_ASSIGNED_LOCKERS
  );
  const partnerBranchAssignmentsByUnassignedLockersQuery = useQuery(
    PARTNER_BRANCH_ASSIGNMENT_BY_UNASSIGNED_LOCKERS
  );
  const [partnerBranchAssignmentsByUnassignedLockers] = useLazyQuery(
    PARTNER_BRANCH_ASSIGNMENT_BY_UNASSIGNED_LOCKERS
  );
  const [partnerBranchAssignmentsByAssignedBranches] = useLazyQuery(
    PARTNER_BRANCH_ASSIGNMENTS_BY_ASSIGNED_BRANCHES
  );
  const [partnerBranchAssignmentsByAssignedLockers, { loading }] = useLazyQuery(
    PARTNER_BRANCH_ASSIGNMENTS_BY_ASSIGNED_LOCKERS
  );
  const [addPartnerBranchAssignment] = useMutation(
    ADD_PARTNER_BRANCH_ASSIGNMENT
  );
  const branches = useQuery(BRANCHES, {
    variables: {
      operatorId: localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user")).operator_id
        : "",
    },
  });
  const [deletePartnerBranchAssignment] = useMutation(
    DELETE_PARTNER_BRANCH_ASSIGNMENT
  );

  const [validation, setValidation] = React.useState({
    icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
    title: "Invalid data",
    message: "",
    open: false,
  });
  const [errorValidation, setErrorValidation] = React.useState({
    icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
    title: "Invalid data",
    message: "",
    open: false,
  });
  const [searchFlag, setSearchFlag] = React.useState(false);
  React.useEffect(() => {
    if (lockerTypes.data) {
      let tempData = [];
      lockerTypes.data.lockerTypes.forEach((element) => {
        tempData.push({
          value: element.lockerTypeId,
          name: element.lockerType,
        });
      });
      dispatch(getLockerTypeList(tempData));
    }
  }, [lockerTypes.data]);
  React.useEffect(() => {
    if (searchPartners.data) {
      let tempData = [];
      searchPartners.data.partners.forEach((element) => {
        tempData.push({
          value: element.partnerId,
          name: element.companyNickname,
        });
      });
      dispatch(getPartnerList(tempData));
    }
  }, [searchPartners.data]);

  const onDeleteLockerAssignment = (event, partnerBranchAssignmentId) => {
    deletePartnerBranchAssignment({
      variables: {
        operatorId: localStorage.getItem("user")
          ? JSON.parse(localStorage.getItem("user")).operator_id
          : "",
        partnerBranchAssignmentId: partnerBranchAssignmentId,
      },
    }).then((data) => {
      partnerBranchAssignmentsByAssignedLockersQuery
        .refetch(searchData)
        .then((data) => {
          setValidation((prev) => ({
            ...prev,
            open: false,
          }));
          setErrorValidation({
            icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
            // title: "Success",
            message: "Successfully removed locker assignment.",
            open: true,
          });
          dispatch(
            getBrachesLockerAssignmentData(
              data.data.partnerBranchAssignmentsByAssignedLockers
            )
          );
        });
      dispatch(getUnassignedLockerList([]));
      partnerBranchAssignmentsByUnassignedLockersQuery
        .refetch(searchData)
        .then((data) => {
          let tempVar = [];
          console.log(data.data.partnerBranchAssignmentsByUnassignedLockers);
          if (data.data.partnerBranchAssignmentsByUnassignedLockers) {
            data.data.partnerBranchAssignmentsByUnassignedLockers.forEach(
              (element) => {
                tempVar.push({
                  value: element.lockerId,
                  label: element.lockerName,
                  branches: element.unassignedPartnerBranches,
                });
              }
            );
            dispatch(getUnassignedLockerList(tempVar));
            dispatch(getUnassignedBranchList([]));
            dispatch(
              handleAssignedBranchLockerData({
                name: "unassignedLocker",
                value: "-1",
              })
            );
            dispatch(
              handleAssignedBranchLockerData({
                name: "partnerBranchId",
                value: "-1",
              })
            );
          }
        });
    });
    // client.clearStore();
  };
  const handleSearchParnerBranchAssignment = () => {
    if (searchData.lockerTypeId === "-1" || searchData.partnerId === "-1") {
      setErrorValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
        title: "Incomplete search criteria",
        message: "Both locker type and partner are required to proceed.",
        open: true,
      });
    } else {
      setSearchFlag(true);
      partnerBranchAssignmentsByAssignedLockers({
        variables: searchData,
      }).then((data) => {
        console.log(data.data.partnerBranchAssignmentsByAssignedLockers);
        dispatch(
          getBrachesLockerAssignmentData(
            data.data.partnerBranchAssignmentsByAssignedLockers
          )
        );
      });
      partnerBranchAssignmentsByUnassignedLockers({
        variables: searchData,
      }).then((data) => {
        let tempVar = [];
        if (data.data.partnerBranchAssignmentsByUnassignedLockers) {
          data.data.partnerBranchAssignmentsByUnassignedLockers.forEach(
            (element) => {
              tempVar.push({
                value: element.lockerId,
                label: element.lockerName,
                branches: element.unassignedPartnerBranches,
              });
            }
          );
          console.log(tempVar);
          dispatch(getUnassignedLockerList(tempVar));
        }
      });
    }
  };

  console.log({ searchData });
  const handleOnChange = (event) => {
    const { name, value } = event.target;
    // setLastBranchValue(null);
    setSearchFlag(false);
    dispatch(handleOnChanged({ name: name, value: value }));
    dispatch(getUnassignedBranchList([]));
    dispatch(
      handleAssignedBranchLockerData({
        name: "lockerId",
        value: [],
      })
    );
    dispatch(
      handleAssignedBranchLockerData({
        name: "partnerBranchId",
        value: "-1",
      })
    );
  };

  const handleOnLockerChange = (event) => {
    const { name, value } = event.target;
    setNoBranchesSimilar(false);
    // if (value.length < 2) setNoBranchesSimilar(false);
    if (name === "lockerId") {
      const lockerId = value;
      let branchList = [];
      let finalBranchList = [];
      let counts = {};

      lockerId.forEach((element, index) => {
        if (unassignedLockerList.find((x) => x.value === element.value)) {
          unassignedLockerList
            .find((x) => x.value === element.value)
            .branches.forEach((element) => {
              // Add Locker ID to the list so it can identify which locker will add
              branchList.push({
                value: element.partnerBranchId,
                name: `${element.partnerBranch}`,
              });
            });
        }
      });
      for (const item of branchList) {
        // Use the item's name as a key in the counts object
        const key = item.value;

        // If the key doesn't exist, initialize it to 1, otherwise increment the count
        counts[key] = counts[key] ? counts[key] + 1 : 1;

        // Output the count for each item
        if (counts[key] === lockerId.length) {
          finalBranchList.push(item);
        }
      }
      if (finalBranchList.length < 1) {
        dispatch(
          handleAssignedBranchLockerData({
            name: "partnerBranchId",
            value: "-1",
          })
        );
        setNoBranchesSimilar(true);
      }
      dispatch(getUnassignedBranchList(finalBranchList));
      dispatch(handleAssignedBranchLockerData({ name: name, value: value }));
    } else if (name === "partnerBranchId") {
      dispatch(handleAssignedBranchLockerData({ name: name, value: value }));
    }
  };
  const handleOnAddPartnerBranchAssignment = (event) => {
    console.log(assignedBranchLockerData);
    if (
      assignedBranchLockerData.lockerId.length > 0 &&
      assignedBranchLockerData.partnerBranchId !== "-1"
    ) {
      setValidation((prev) => ({
        ...prev,
        open: false,
      }));
      setModify(true);
      assignedBranchLockerData.lockerId.forEach((element) => {
        let tempAssgnedBranchLocker = { ...assignedBranchLockerData };
        tempAssgnedBranchLocker.lockerId = element.value;
        addPartnerBranchAssignment({
          variables: tempAssgnedBranchLocker,
        })
          .then((data) => {
            partnerBranchAssignmentsByAssignedLockersQuery
              .refetch(searchData)
              .then((data) => {
                setErrorValidation({
                  icon: `${process.env.PUBLIC_URL}/assets/images/check.png`,
                  title: "Success",
                  message: "Successfully assigned locker.",
                  open: true,
                });
                setModify(false);
                dispatch(
                  getBrachesLockerAssignmentData(
                    data.data.partnerBranchAssignmentsByAssignedLockers
                  )
                );
                dispatch(
                  handleAssignedBranchLockerData({
                    name: "lockerId",
                    value: [],
                  })
                );
                dispatch(
                  handleAssignedBranchLockerData({
                    name: "partnerBranchId",
                    value: "-1",
                  })
                );
              });
            dispatch(getUnassignedLockerList([]));
            partnerBranchAssignmentsByUnassignedLockersQuery
              .refetch(searchData)
              .then((data) => {
                let tempVar = [];
                console.log(
                  data.data.partnerBranchAssignmentsByUnassignedLockers
                );
                if (data.data.partnerBranchAssignmentsByUnassignedLockers) {
                  data.data.partnerBranchAssignmentsByUnassignedLockers.forEach(
                    (element) => {
                      tempVar.push({
                        value: element.lockerId,
                        label: element.lockerName,
                        branches: element.unassignedPartnerBranches,
                      });
                    }
                  );
                  dispatch(getUnassignedLockerList(tempVar));
                  dispatch(getUnassignedBranchList([]));
                  dispatch(
                    handleAssignedBranchLockerData({
                      name: "unassignedLocker",
                      value: "-1",
                    })
                  );
                  dispatch(
                    handleAssignedBranchLockerData({
                      name: "partnerBranchId",
                      value: [],
                    })
                  );
                }
              });
          })
          .catch((e) => {
            console.log(e);
          });
      });

      // client.clearStore();
    } else {
      console.log(assignedBranchLockerData);
      setErrorValidation({
        icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
        title: "Incomplete data",
        message: "Locker and Branch is required to proceed.",
        open: true,
      });
    }
  };
  const handleCancelAssignLocker = () => {
    dispatch(getUnassignedLockerList([]));
    partnerBranchAssignmentsByUnassignedLockersQuery
      .refetch(searchData)
      .then((data) => {
        let tempVar = [];
        console.log(data.data.partnerBranchAssignmentsByUnassignedLockers);
        if (data.data.partnerBranchAssignmentsByUnassignedLockers) {
          data.data.partnerBranchAssignmentsByUnassignedLockers.forEach(
            (element) => {
              tempVar.push({
                value: element.lockerId,
                label: element.lockerName,
                branches: element.unassignedPartnerBranches,
              });
            }
          );
          dispatch(getUnassignedLockerList(tempVar));
          dispatch(getUnassignedBranchList([]));
          dispatch(
            handleAssignedBranchLockerData({
              name: "unassignedLocker",
              value: "-1",
            })
          );
          dispatch(
            handleAssignedBranchLockerData({
              name: "partnerBranchId",
              value: "-1",
            })
          );
        }
      });
  };
  // React.useEffect(() => {
  // 	handleSearchParnerBranchAssignment();
  // }, [searchData.partnerId]);
  React.useEffect(() => {
    dispatch(clearSearchData());
    setSearchFlag(false);
  }, []);
  return (
    <ContentContainer containerTitle={"Assign to Branch"}>
      <div className="w-4/5 grid grid-cols-5 gap-2">
        <div className="col-span-1">
          <p className="text-base mt-2">Locker Type: </p>
        </div>
        <div className="bg-slate-50 col-span-3">
          <Select
            value={searchData.lockerTypeId}
            items={lockerTypeList}
            defaultOption={{ value: "-1", name: "-- Select Locker Type --" }}
            onChange={handleOnChange}
            name="lockerTypeId"
          />
        </div>
        <div className="col-span-1"></div>
        {/*  */}
        <div className="col-span-1">
          <p className="text-base mt-2">Partner: </p>
        </div>
        <div className="bg-slate-50 col-span-3">
          <Select
            value={searchData.partnerId}
            items={partnerList}
            defaultOption={{ value: "-1", name: "-- Select a Partner--" }}
            onChange={handleOnChange}
            name="partnerId"
          />
        </div>
        <div className="col-span-1 flex">
          <Button
            className={"p-2"}
            value={"Search"}
            onClick={handleSearchParnerBranchAssignment}
          />
        </div>
      </div>
      <hr className="mt-4 mb-4"></hr>
      {accessPermission.assignToBranch === "1" ||
      accessPermission.assignToBranch === 1 ? (
        <></>
      ) : (
        <>
          {searchData.lockerTypeId !== "-1" &&
            searchData.partnerId !== "-1" &&
            searchFlag &&
            brachesLockerAssignmentData.length > 0 && (
              <>
                <div className="w-4/5 grid grid-cols-5 gap-2">
                  <div className="col-span-1">
                    <p className="text-base mt-2">
                      Select{" "}
                      <b>
                        {lockerTypeList.find(
                          (x) =>
                            parseInt(x.value) ===
                            parseInt(searchData.lockerTypeId)
                        ) &&
                          lockerTypeList.find(
                            (x) =>
                              parseInt(x.value) ===
                              parseInt(searchData.lockerTypeId)
                          ).name}
                      </b>{" "}
                      Locker:
                    </p>
                  </div>
                  <div className="bg-slate-50 col-span-3">
                    {/* <Select
										items={unassignedLockerList}
										value={assignedBranchLockerData.lockerId}
										defaultOption={{ value: "-1", name: "-- Select a Locker --" }}
										name="unassignedLocker"
										onChange={handleOnLockerChange}
									/> */}
                    <MultiSelect
                      items={unassignedLockerList}
                      value={assignedBranchLockerData.lockerId}
                      defaultOption={{
                        value: "-1",
                        name: "-- Select a Branch --",
                      }}
                      onChange={handleOnLockerChange}
                      name="lockerId"
                    />
                  </div>
                  <div className="col-span-1"></div>
                  <div className="col-span-1">
                    <p className="text-base mt-2">
                      Assign to{" "}
                      <b>
                        {partnerList.find(
                          (x) => x.value === searchData.partnerId
                        ) &&
                          partnerList.find(
                            (x) => x.value === searchData.partnerId
                          ).name}
                      </b>{" "}
                      Branch
                    </p>
                  </div>
                  <div className="bg-slate-50 col-span-3">
                    {noBranchesSimilar &&
                    assignedBranchLockerData.lockerId.length > 0 ? (
                      <p className="text-red-800 font-bold text-center mx-auto">
                        No common branch/branches to selected lockers
                      </p>
                    ) : (
                      <Select
                        value={assignedBranchLockerData.partnerBranchId}
                        items={unassignedBranchList}
                        defaultOption={{
                          value: "-1",
                          name: "-- Select a Branch --",
                        }}
                        onChange={handleOnLockerChange}
                        name="partnerBranchId"
                      />
                    )}
                  </div>
                  <div className="col-span-1">
                    <Button
                      onClick={handleOnAddPartnerBranchAssignment}
                      className={"w-full h-full mr-2 p-2"}
                      value="Assign Locker to branch"
                    />
                  </div>
                  <div className="col-span-1"></div>
                </div>
                <hr className="mt-4 mb-4"></hr>
              </>
            )}
        </>
      )}

      <LinearProgressBar label="" open={modify} />

      {searchFlag &&
        (brachesLockerAssignmentData.length > 0 ? (
          <div>
            <hr className="mt-4"></hr>
            <OutputTable
              disabled={
                accessPermission.assignToBranch === "1" ||
                accessPermission.assignToBranch === 1
              }
              title={
                partnerList.find((x) => x.value === searchData.partnerId) &&
                partnerList.find((x) => x.value === searchData.partnerId).name
              }
              lockerType={
                lockerTypeList.find(
                  (x) => x.value === searchData.lockerTypeId
                ) &&
                lockerTypeList.find((x) => x.value === searchData.lockerTypeId)
                  .name
              }
              headers={[
                {
                  header_name: "Lockers",
                  header_key: "lockerName",
                },
                {
                  header_name: "Branches",
                  header_key: "assignedBranches",
                },
              ]}
              items={brachesLockerAssignmentData}
              onDelete={(event, partnerBranchAssignmentId, doorsOccupied) => {
                console.log(doorsOccupied);
                setValidation({
                  icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
                  title: "UNASSIGN BRANCH",
                  message:
                    "Do you want to remove this branch assignment from this locker?",
                  open: true,
                  header: {
                    event: event,
                    partnerBranchAssignmentId: partnerBranchAssignmentId,
                    doorsOccupied: doorsOccupied,
                  },
                });
              }}
            />
          </div>
        ) : loading ? (
          <LinearProgressBar label="" open={loading} />
        ) : (
          <NoDataFoundTemplate width={56} height={56} />
        ))}
      {/* Modal for removing confirmation */}
      <Modal
        icon={validation.icon}
        title={validation.title}
        message={validation.message}
        open={validation.open}
        actions={
          <div className="grid grid-cols-2 gap-2">
            <Button
              onClick={() => {
                setValidation((prev) => ({
                  ...prev,
                  open: false,
                }));
              }}
              value={"No"}
              className={"p-2"}
            />
            <Button
              onClick={() =>
                onDeleteLockerAssignment(
                  validation.header.event,
                  validation.header.partnerBranchAssignmentId
                )
              }
              value={"Yes"}
              className={"p-2"}
            />
          </div>
        }
      />
      {/* Modal for Error Vaidation */}
      <Modal
        icon={errorValidation.icon}
        title={errorValidation.title}
        message={errorValidation.message}
        open={errorValidation.open}
        actions={
          <div className="grid grid-cols-1 gap-2">
            <Button
              onClick={() => {
                setErrorValidation((prev) => ({
                  ...prev,
                  open: false,
                }));
              }}
              value={"OK"}
              className={"p-2"}
            />
          </div>
        }
      />
    </ContentContainer>
  );
}
